import { render } from "./head_searchbox.vue?vue&type=template&id=10f837b3&scoped=true"
import script from "./head_searchbox.vue?vue&type=script&lang=js"
export * from "./head_searchbox.vue?vue&type=script&lang=js"

import "./head_searchbox.vue?vue&type=style&index=0&id=10f837b3&scoped=true&lang=less"
script.render = render
script.__scopeId = "data-v-10f837b3"

export default script